import { createSelector } from '@reduxjs/toolkit';

import { getProjectIrisForModelId } from 'src/containers/ProjectDiagram/utils/projectModelIds';
import { projectSelector } from 'src/selectors/project';

export const projectIrisForModelIdSelector = (
  projectId: string,
  modelId: string
) =>
  createSelector(projectSelector(projectId), (project) =>
    project && modelId
      ? getProjectIrisForModelId(modelId, project.diagram.model)
      : []
  );
